module.exports = __webpack_public_path__ + "img/gratification-trash.849861e0.svg";